<mat-radio-group
  class="flex-column"
  [value]="selectedStickerPartType"
  (change)="typeSelected($event.value)"
>
  <mat-radio-button
    *ngFor="let option of STICKER_PART_TYPE_CHOICES_ARRAY"
    [ngClass]="
      selectedStickerPartType != null && selectedStickerPartType !== option
        ? 'unselected'
        : ''
    "
    [value]="option"
  >
    <span class="strong">{{ option.label }}</span>
  </mat-radio-button>
</mat-radio-group>

<div class="more-upper-space">
  <client-window-sticker-standard-part-form
    *ngIf="
      selectedStickerPartType ===
      STICKER_PART_TYPE_CHOICES.STANDARD_STICKER_PART
    "
    [windowSticker]="windowSticker"
    [standardStickerPart]="part.instance"
    [windowStickerSizeGetter]="windowStickerSizeGetter"
  ></client-window-sticker-standard-part-form>

  <client-window-sticker-custom-part-form
    *ngIf="
      selectedStickerPartType === STICKER_PART_TYPE_CHOICES.CUSTOM_STICKER_PART
    "
    [stickerPart]="part.instance"
  ></client-window-sticker-custom-part-form>
</div>
